import { render, staticRenderFns } from "./AsModal.vue?vue&type=template&id=23375bf1&scoped=true"
import script from "./AsModal.vue?vue&type=script&lang=ts"
export * from "./AsModal.vue?vue&type=script&lang=ts"
import style0 from "./AsModal.vue?vue&type=style&index=0&id=23375bf1&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23375bf1",
  null
  
)

export default component.exports